import * as React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

interface TooltipWrapperProps {
	title: string;
	position?: "top" | "bottom" | "left" | "right";
	children: React.ReactElement;
	duration?: number;
}

export const TooltipWrapper: React.FC<TooltipWrapperProps> = ({
	title,
	position = "top",
	duration = 150,
	children,
}) => {
	return (
		<Tooltip delayDuration={duration}>
			<TooltipTrigger asChild>{children}</TooltipTrigger>
			<TooltipContent side={position} className="max-w-sm">
				<p>{title}</p>
			</TooltipContent>
		</Tooltip>
	);
};
